import activity from './activity.it.json';
import assets from './assets.it.json';
import auth from './auth.it.json';
import commissions from './commissions.it.json';
import common from './common.it.json';
import dashboard from './dashboard.it.json';
import payouts from './payouts.it.json';
import profile from './profile.it.json';
import rewards from './rewards.it.json';
import rewardsV3 from './rewardsV3.it.json';
import shareLink from './shareLink.it.json';
import stats from './stats.it.json';
import transactions from './transactions.it.json';

const it = {
  activity,
  assets,
  auth,
  commissions,
  common,
  dashboard,
  payouts,
  profile,
  rewards,
  rewardsV3,
  shareLink,
  stats,
  transactions,
};

export default it;
